import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefAlerts from "table-defs/TableDefAlerts";
import { toggleDropdowns } from "../../../helpers/utils";

import {
    loadAlertsAction,
    updateAlertsAction,
    loadSitesAction
} from "store/actions/Actions";

import useFilterRows from "helpers/customHooks/useFilterRows";

import { setSelectedRows } from "helpers/utils";

const Alerts = props => {
    const [state, setState] = useState({
        selectedRows: null,
        selected_sites: []
    });
    const { loadSitesAction, updateAlertsAction, loadAlertsAction, SitesReducer, AlertsReducer } = props;

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!AlertsReducer.alerts && SitesReducer.sites) {
            loadAlertsAction();
        }
    }, [AlertsReducer.alerts, SitesReducer.sites, loadAlertsAction]);

    // ##############################################

    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        start: "",
        end: "",
        selected_sites: [],
        dateField: "alerted_on"
    };

    const [filters, setFilters] = useState(noFilters);

    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
    };

    const setDateFilter = filterName => value => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    };

    const filteredRows = useFilterRows(filters, AlertsReducer.alerts);

    // ##############################################

    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({
                ...s,
                selectedRows
            }));
        }
    };

    const chooseActionDropdownRef = React.createRef();
    const statusDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();

    const [selectedAlertsIds, setSelectedAlertsIds] = useState([]);

    const handleNotify = (ids) => {
        console.log('TODO: handling notify here...');
    }

    const handleMarkRead = (ids) => {
        if (Array.isArray(ids)) {
            updateAlertsAction(ids.map(item => {
                item.active = false;
                item.organization = 1;
                return item;
            }));
        } else {
            updateAlertsAction([{
                id: ids,
                active: false,
            }]);
        }
    }

    return (
        <AppLayoutWrapFull onClick={toggleDropdowns([chooseActionDropdownRef, statusDropdownRef, siteDropdownRef])}>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    searchHandler={e =>
                        setFilters({ ...filters, text: e.target.value || "" })
                    }
                    searchValue={filters.text}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    chooseAction={[
                        {
                            actionName: "Notify Selected",
                            actionHandler: () => handleNotify(selectedAlertsIds)
                        },
                        {
                            actionName: "Mark Selected As Read",
                            actionHandler: () => handleMarkRead(selectedAlertsIds)
                        }
                    ]}
                    site={{
                        onClick: (e) => {
                            if (e.target.type === 'checkbox') {
                                let selected_sites = filters.selected_sites.slice();
                                if (e.target.checked) {
                                    selected_sites.push(e.target.value);
                                } else {
                                    selected_sites = selected_sites.filter(site => site !== e.target.value);
                                }
                                setFilters({
                                    ...filters,
                                    site: selected_sites.length > 0 ? `Sites (${selected_sites.length})` : 'Site',
                                    // site: "Site",
                                    selected_sites: selected_sites
                                });
                            }
                        },
                        sites: SitesReducer.sites ? SitesReducer.sites.map(site => {
                            return {
                                id: site.id,
                                siteName: site.name,
                                value: filters.selected_sites.includes(site.id) ? true : false
                            }
                        }) : [],
                    }}
                    siteDropdownRef={siteDropdownRef}
                    status={{
                        onChange: setFilter("status"),
                        options: ["All", "New", "Read"],
                    }}
                    statusDropdownRef={statusDropdownRef}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    filters={filters}
                    resetFilters={() => setFilters(noFilters)}
                />
            </PageHeader>
            <Container wide fluid>
                {AlertsReducer.alerts &&
                    <FullDataTable
                        rowsData={filteredRows}
                        definitions={TableDefAlerts}
                        onChangeRowSelect={({ selectedRows }) => onChangeRowSelect({ selectedRows })}
                        customTableProps={{
                            selectedRows: state.selectedRows,
                            handleNotify: handleNotify,
                            handleMarkRead: handleMarkRead
                        }}
                        setSelectedRows={setSelectedRows(["id"], setSelectedAlertsIds)}
                        filters={filters || {}}
                    />
                }
            </Container>
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = state => ({
    AlertsReducer: state.AlertsReducer,
    SitesReducer: state.SitesReducer
});

const mapDispatchToProps = {
    loadSitesAction,
    loadAlertsAction,
    updateAlertsAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Alerts);
